//http://localhost:3000/detectReferal/Zerodha/aMiat
import React, { useEffect, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import {
  setThemeColors,
  setGradientColors,
} from "../../designs/v1/redux/actions";
import { getCentralURL } from "../../config";

const DetectPromoCode = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { promoCode, brokerID } = useParams();

  const setPromoCode = useCallback(() => {
    sessionStorage.clear();
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    const URL = getCentralURL();
    axios
      .post(
        `${URL}/api/method/central_system.apis.broker.api.get_broker_details`,
        {
          broker_id: brokerID,
        },
        headers
      )
      .then((result) => {
        let { data } = result.data;
        window.sessionStorage.setItem("broker_id", brokerID);
        axios
          .get(
            data.broker_basic_detail.portal_domain +
            "/api/method/kyc_customizations.apis.kyc_page.api.get_broker_setup_settings"
          )
          .then((result1) => {
            window.sessionStorage.setItem(
              "favicon",
              result1.data.data?.favicon
            );
            window.sessionStorage.setItem("logo", result1.data.data.logo);
            window.sessionStorage.setItem("on_screen_esign", result1.data.data.on_screen_esign);
            window.sessionStorage.setItem(
              "is_nomination_det_req",
              result1.data.data.is_nomination_det_req
            );
            window.sessionStorage.setItem(
              "theme_color_pallate",
              JSON.stringify(result1.data.data.theme_color_pallate)
            );
            window.sessionStorage.setItem(
              "theme_landing_image",
              result1.data.data.theme_landing_image
            );
            window.sessionStorage.setItem(
              "joint_holder",
              result1.data.data.joint_holder
            );
            window.sessionStorage.setItem(
              "other_as_occupation",
              JSON.stringify(result1.data.data.other_as_occupation)
            );
            window.sessionStorage.setItem(
              "gradientColor",
              JSON.stringify(result1.data.data.gradientColor)
            );
            dispatch(setThemeColors(result1.data.data.theme_color_pallate));
            dispatch(setGradientColors(result1.data.data.gradientColor));
          })
          .catch((error) => {
            console.log(error);
          });

        window.sessionStorage.setItem(
          "broker_name",
          data.broker_basic_detail.broker_name
        );
        window.sessionStorage.setItem(
          "portal_domain",
          data.broker_basic_detail.portal_domain
        );
        window.sessionStorage.setItem("promo_code", promoCode);

        history.push("/");
      })
      .catch((error) => {
        console.log(error);
        alert("This link is not valid.");
      });
  }, [dispatch, brokerID, history, promoCode]);

  useEffect(() => {
    setPromoCode();
  }, [setPromoCode]);

  return (
    <div className="flex h-100 justify-center align-center flex-column">
      <div className="mt-5">
        <Spinner animation="grow" />
      </div>
      <div>Please Wait...</div>
    </div>
  );
};

export default DetectPromoCode;
